import { useState } from 'react';
import jwt from 'jsonwebtoken';
import AppConfig from '@config';
import useClient from '@hooks/useClient';
import {
  useVerifyCompanyRegistrationNumberQuery,
  CapaServiceType,
  CapaErrorCode,
  CapaQuotationUserBizType
} from '@generated/graphql';
import { STORAGE_ACTION } from '@utils/storage';

const useSwitchService = () => {
  const [openDuplicatedDialog, setOpenDuplicatedDialog] = useState<boolean>(
    false
  );
  const accessToken = localStorage.getItem(STORAGE_ACTION.CLIENT_ACCESS_TOKEN);
  const refreshToken = localStorage.getItem(
    STORAGE_ACTION.CLIENT_REFRESH_TOKEN
  );
  const { clientState } = useClient();
  const DecodedAccessToken = accessToken
    ? JSON.parse(JSON.stringify(jwt.decode(accessToken)))
    : {};
  const {
    refetch: checkRegistrationNumber
  } = useVerifyCompanyRegistrationNumberQuery({
    skip: true
  });
  const authQuery =
    accessToken && refreshToken
      ? `/auth/?accessToken=${accessToken}&refreshToken=${refreshToken}`
      : '/auth';

  const checkDuplicated = async () => {
    const { companyRegistrationNumber, bizType } = clientState;
    if (companyRegistrationNumber && bizType === CapaQuotationUserBizType.Biz) {
      const { data } = await checkRegistrationNumber({
        input: { companyRegistrationNumber }
      });

      if (
        data?.verifyCompanyRegistrationNumber.result ===
        CapaErrorCode.DuplicateCompanyRegistrationNo
      ) {
        return true;
      }
    }
    return false;
  };

  const handleSwitchService = async (service: CapaServiceType) => {
    const hasServiceAccount = DecodedAccessToken?.scopes?.includes(service);
    const isLocalhost = window.location.hostname === 'localhost';

    switch (service) {
      case CapaServiceType.QuotationPartner: {
        const isDuplicated = await checkDuplicated();
        if (!hasServiceAccount && isDuplicated) {
          return setOpenDuplicatedDialog(true);
        } else {
          return (window.location.href = `${
            isLocalhost ? `http://localhost:3000` : AppConfig.partnersUrl
          }${authQuery}`);
        }
      }
      case CapaServiceType.Cloud: {
        return (window.location.href = `${
          isLocalhost ? `http://localhost:3000` : AppConfig.cloudUrl
        }${authQuery}`);
      }

      case CapaServiceType.Connect: {
        return (window.location.href = `${
          isLocalhost ? `http://localhost:3000` : AppConfig.connectUrl
        }${authQuery}`);
      }
    }
  };

  return { openDuplicatedDialog, setOpenDuplicatedDialog, handleSwitchService };
};

export default useSwitchService;
